import Geolocation from 'ol/Geolocation';
import {getLocationReversed} from "@/http/services/http-services-route";
import {transform, transformExtent} from "ol/proj";
import {viewFit} from "@/helpers/ol-view";
import {Point} from "ol/geom";
import {addNewNotificationLayerClick} from "@/helpers/location-search-helper";
import {setLayerClick} from "@/helpers/ol-layer-helper";

let loaded = false

export function initGeoLocation(element) {
    element.addEventListener('click', () => {
        getGeoLocation()
    })
}

export function getGeoLocation() {
    const geolocation = new Geolocation({
        // enableHighAccuracy must be set to true to have the heading value.
        trackingOptions: {
            enableHighAccuracy: true,
        },
        projection: window.map.getView().getProjection(),
    });

    geolocation.setTracking(true);
    geolocation.on('change:position', function () {
        if(!loaded) {
            const coordinates = geolocation.getPosition();
            loaded = true

            const result = transform(coordinates, 'EPSG:3857', 'EPSG:4326')

            addNewNotificationLayerClick(coordinates, window.map)

            viewFit(
                new Point(coordinates),
                [10, 10, 10, 10],
                18,
                0
            )
            setLayerClick(coordinates)

            getLocationReversed(result[1], result[0]).then( result => {
                document.getElementById('iptNewNotificationLocation').value = result.adres.weergavenaam
            })
        }
    });
}
